import {omneticApi} from '@dms/api/base';
import {
  GetServiceCaseApiResponse,
  GetServiceCaseApiArg,
  CreateServiceCaseApiResponse,
  CreateServiceCaseApiArg,
} from '@dms/api/shared';

export const workshopApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getServiceCase: build.query<GetServiceCaseApiResponse, GetServiceCaseApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/service-case/${queryArg.serviceCaseId}`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'ServiceCase', id: queryArg.serviceCaseId},
      ],
    }),
    createServiceCase: build.mutation<CreateServiceCaseApiResponse, CreateServiceCaseApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/service-case`,
        method: 'POST',
        body: queryArg.createServiceCaseRequestBody,
      }),
      invalidatesTags: [{type: 'ServiceCase', id: 'LIST'}],
    }),
  }),
});

export const {useGetServiceCaseQuery, useCreateServiceCaseMutation} = workshopApi;
